/* ---------------------------------------------------------------------------------------------------------------------
   LENUMA GESCHENK
   ---------------------------------------------------------------------------------------------------------------------
   Legt das eingestellte Geschenk automatisch in den Warenkorb, sobald dort ein
   anderes Produkt liegt, und nimmt es wieder heraus, wenn der Warenkorb sonst
   leer ist.

   Die Geschenk-Position wird ueber die Eigenschaft _lenuma_gift markiert.
   Eigenschaften mit fuehrendem Unterstrich blendet Shopify in der Anzeige aus,
   und das Theme kann die Zeile daran erkennen, ohne die Variante zu vergleichen.
   Das ueberlebt auch einen spaeteren Wechsel des Geschenk-Produkts.

   Der Preis kommt NICHT von hier. Das Geschenk liegt zum reglaeren Preis im
   Warenkorb und wird von einem automatischen Rabatt in Shopify auf 0 gezogen.
   Alles andere waere im Checkout nicht durchsetzbar.
   --------------------------------------------------------------------------------------------------------------------- */

(function () {
  const config = window.lenumaGift;
  if (!config || !config.enabled || !config.variantId) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Eigene Referenz auf fetch, damit spaetere Wrapper anderer Skripte
     diese Aufrufe nicht erneut durch die Geschenk-Logik schicken. */
  const request = window.fetch.bind(window);

  let running = false;

  function isGift(item) {
    return Boolean(item.properties && item.properties._lenuma_gift);
  }

  async function getCart() {
    const response = await request(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return response.json();
  }

  async function post(path, body) {
    return request(`${root}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  /* Gibt true zurueck, wenn der Warenkorb veraendert wurde. Nur dann muss
     das Theme neu zeichnen - sonst blinkt der Drawer bei jedem Klick. */
  async function sync() {
    if (running) return false;
    running = true;

    try {
      const cart = await getCart();
      const items = cart.items || [];
      const gift = items.find(isGift);
      const hasOther = items.some((item) => !isGift(item));

      if (hasOther && !gift) {
        await post('cart/add.js', {
          items: [{ id: config.variantId, quantity: 1, properties: { _lenuma_gift: 'true' } }],
        });
        return true;
      }

      if (!hasOther && gift) {
        await post('cart/change.js', { id: gift.key, quantity: 0 });
        return true;
      }

      /* Sicherheitsnetz: falls die Menge doch einmal hochgeht, etwa weil
         jemand den Warenkorb-Link mit Parametern aufruft. */
      if (gift && gift.quantity > 1) {
        await post('cart/change.js', { id: gift.key, quantity: 1 });
        return true;
      }

      return false;
    } catch (error) {
      /* Ein fehlgeschlagener Geschenk-Abgleich darf den Kauf nie blockieren. */
      console.warn('[lenuma-gift]', error);
      return false;
    } finally {
      running = false;
    }
  }

  async function syncAndRedraw() {
    const changed = await sync();
    if (changed) {
      /* Das Theme hoert auf cart:refresh und zeichnet den Drawer komplett neu. */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  /* Das Theme feuert cart:change nach jedem Hinzufuegen und jeder Mengenaenderung.
     Wir haengen uns dahinter, statt fetch zu ueberschreiben - das bleibt
     nachvollziehbar und kollidiert nicht mit Apps. */
  document.addEventListener('cart:change', () => {
    syncAndRedraw();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAndRedraw, { once: true });
  } else {
    syncAndRedraw();
  }
})();
